import { useEffect } from 'react'

import { useMutation, useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'
import { useContextStore } from '@/stores/context'

import type { UserAccountContextsResponse } from './get-user-account-contexts.types'

const getUserAccountContexts =
  async (): Promise<UserAccountContextsResponse> => {
    const response = await apiClient.get<UserAccountContextsResponse>(
      '/v1/auth/user-account-contexts',
    )
    return response.data
  }

/**
 * Hook to get all user account contexts (query version)
 * GET /v1/auth/user-account-contexts
 */
export const useUserAccountContexts = () => {
  const setAvailableAccounts = useContextStore(
    (state) => state.setAvailableUserAccounts,
  )

  const query = useQuery({
    queryKey: ['user-account-contexts'],
    queryFn: () => getUserAccountContexts(),
  })

  // Sync data to store when available
  useEffect(() => {
    if (query.data) {
      setAvailableAccounts(query.data.items)
    }
  }, [query.data, setAvailableAccounts])

  return query
}

/**
 * Hook to get all user account contexts (mutation version)
 * GET /v1/auth/user-account-contexts
 */
export const useUserAccountContextsMutation = () => {
  return useMutation({
    mutationFn: () => getUserAccountContexts(),
    meta: {
      skipErrorMessage: true,
    },
  })
}
